// 校验手机号
const validTel = (tel) => {
    const reg = /^1[3456789][0-9]{9}$/;
    return reg.test(tel);
}

// 校验邮箱
const validEmail = (email) => {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(email);
}

// 校验密码
// 英文+数字+特殊字符，区分大小写，最少6个字符，最长16个字符
const validPwd = (pwd) => {
    const reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E])[a-zA-Z\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]{6,16}$/;
    return reg.test(pwd);
}

// 是否包含汉字
const validChinese = (str) => {
    const reg = /[\u4e00-\u9fa5]+/g;
    return reg.test(str);
}

// 是否包含英文
const validEnglish = (str) => {
    const reg = /[a-zA-Z]+/g;
    return reg.test(str);
}

const storage = {
    /* localStorage */
    ls: {
        set(key, value) {
            if (typeof value === 'object') {
                localStorage.setItem(key, JSON.stringify(value));
            } else {
                localStorage.setItem(key, value);
            }
        },
        get(key) {
            const content = localStorage.getItem(key);
            if (content) {
                try {
                    return JSON.parse(content);
                } catch (e) {
                    return content;
                }
            } else {
                return null;
            }
        },
        remove(key) {
            localStorage.removeItem(key);
        },
        clear() {
            localStorage.clear();
        },
    },
    /* sessionStorage */
    ss: {
        set(key, value) {
            if (typeof value === 'object') {
                sessionStorage.setItem(key, JSON.stringify(value));
            } else {
                sessionStorage.setItem(key, value);
            }
        },
        get(key) {
            const content = sessionStorage.getItem(key);
            if (content) {
                try {
                    return JSON.parse(content);
                } catch (e) {
                    return content;
                }
            } else {
                return null;
            }
        },
        remove(key) {
            sessionStorage.removeItem(key);
        },
        clear() {
            sessionStorage.clear();
        },
    },
};

export default {
    storage,
    validTel,
    validEnglish,
    validChinese,
    validPwd,
    validEmail,
};
